module.exports = __webpack_public_path__ + "static/media/icon-spotify.adfdee0f.svg";